import Header from './Layout/Header';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import dayjs from 'dayjs';
import Sidebar from './Layout/Sidebar';
import { Layout } from 'antd';
import moment from 'moment';

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { dataUser } from './Helpers/util';
import { WALLET_POINT_AUTHORIZATION } from '../constant';
import CustomHeader from './Layout/Header';
import axiosInstance from '../utils/axiosInstance';
import AntDDatePicker from './Common/AntDDateTimePicker/AntDDatePicker';
import SwButton from './Common/SwButtons/SwButtons';
import AntDTable from './Common/AntDTable/AntDTable';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function MealPlanTransaction({ }) {
  const today = dayjs();
  const threeMonthsAgoStart = today.subtract(3, 'month').startOf('month');

  const [collapsed, setCollapsed] = useState(true);
  const [companyPointData, setCompanyPointData] = useState([]);
  const [filteredCompanyPointData, setFilteredCompanyPointData] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [startDate, setStartDate] = useState(today.startOf('month'));
  const [endDate, setEndDate] = useState(today);
  const [appliedStartDate, setAppliedStartDate] = useState(today.startOf('month'));
  const [appliedEndDate, setAppliedEndDate] = useState(today);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortColumn, setSortColumn] = useState(null);

  const getLedgerReportData = async () => {
    setSpinner(true);
    const authToken = localStorage.getItem('token');
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/transactions/getCompanyMealPlanTransactions/${appliedStartDate.format('MM/YYYY')}/${UserObj ? UserObj?.company_id : null}`,
        {
          dateFilter: '',
          startDate: appliedStartDate.format('YYYY-MM-DD'),
          endDate: appliedEndDate.format('YYYY-MM-DD'),
        },
        {
          headers: {
            Authorization: `${authToken}`,
          },
        },
      );
      if (res.data.message === 'Data Found') {
        setCompanyPointData(res.data.transactions);
      } else {
        setCompanyPointData([]);
        setFilteredCompanyPointData([]);
      }
    } catch (error) {
      console.error('Error fetching meal plan transactions:', error);
      setCompanyPointData([]);
      setFilteredCompanyPointData([]);
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    getLedgerReportData();
  }, [appliedStartDate, appliedEndDate]);


  useEffect(() => {
    const startStr = appliedStartDate.format('YYYY-MM-DD');
    const endStr = appliedEndDate.format('YYYY-MM-DD');
    const filteredData = companyPointData.filter(item => {
      const d = moment(item['Date']).format('YYYY-MM-DD');
      return d >= startStr && d <= endStr;
    });
    setFilteredCompanyPointData(filteredData);
  }, [appliedStartDate, appliedEndDate, companyPointData]);

  const disabledStartDate = current =>
    current && (current.isBefore(threeMonthsAgoStart, 'day') || current.isAfter(today, 'day'));

  const disabledEndDate = current => {
    if (!current) return false;
    if (current.isBefore(threeMonthsAgoStart, 'day') || current.isAfter(today, 'day')) return true;
    if (startDate) {
      if (current.isBefore(startDate, 'day')) return true;
      if (current.month() !== startDate.month() || current.year() !== startDate.year()) return true;
    }
    return false;
  };

  const handleApply = () => {
    if (!startDate || !endDate) return;
    if (startDate.isSame(appliedStartDate, 'day') && endDate.isSame(appliedEndDate, 'day')) {
      getLedgerReportData();
      return;
    }
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
  };

  const isPristine =
    startDate && endDate &&
    startDate.isSame(appliedStartDate, 'day') &&
    endDate.isSame(appliedEndDate, 'day');

  const handleSort = columnName => {
    const sortedData = [...filteredCompanyPointData].sort((a, b) => {
      if (sortDirection === 'asc') {
        return a[columnName] > b[columnName] ? 1 : -1;
      } else {
        return a[columnName] < b[columnName] ? 1 : -1;
      }
    });

    setFilteredCompanyPointData(sortedData);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(columnName);
  };

  const handleSortByAmount = () => {
    handleSort('Amount');
  };

  const handleExport = () => {
    const formattedData = filteredCompanyPointData?.map(item => ({
      Date: moment(item['Date']).format('DD-MM-YYYY HH:mm:ss'),
      Name: item['Name'],
      Email: item['Email'],
      'Employee Code':
        item['Employee Code'] === '' || !item['Employee Code']
          ? '-'
          : item['Employee Code'],
      'Shopify Order ID': item['Shopify Order ID'],
      Vendor: item['Vendor'],
      Center: item['Center'],
      'Plan Name': item['Plan Name'],
      Amount: item['Amount'],
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const excelBlob = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(excelBlob, 'MealPlanReport.xlsx');
  };

  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      sorter: true,
      render: (date) =>
        moment(date).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      sorter: true,
    },
    {
      title: "Employee Code",
      dataIndex: "Employee Code",
      key: "Employee Code",
      sorter: true,
      render: (val) => val || "-",
    },
    {
      title: "Shopify Order ID",
      dataIndex: "Shopify Order ID",
      key: "Shopify Order ID",
      sorter: true,
    },
    {
      title: "Vendor",
      dataIndex: "Vendor",
      key: "Vendor",
      sorter: true,
    },
    {
      title: "Center",
      dataIndex: "Center",
      key: "Center",
      sorter: true,
    },
    {
      title: "Plan Name",
      dataIndex: "Plan Name",
      key: "Plan Name",
      sorter: true,
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      sorter: true,
    },
  ];


  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />

        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div className="PageContent">

            <div className="row mb-3">

              <div className="col-md-12">
                <div className="SwHeading">
                  <h2>Meal Plan Report</h2>
                </div>

                <div className="row align-items-center mb-2">

                  <div className="col-md-3">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">Start Date</label>
                      <AntDDatePicker
                        format="YYYY-MM-DD"
                        placeholder="Select start date"
                        value={startDate}
                        disabledDate={disabledStartDate}
                        onChange={date => {
                          setStartDate(date);
                          if (date && endDate && (endDate.isBefore(date, 'day') || endDate.month() !== date.month() || endDate.year() !== date.year())) {
                            setEndDate(date);
                          }
                        }}
                        allowClear={false}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">End Date</label>
                      <AntDDatePicker
                        format="YYYY-MM-DD"
                        placeholder="Select end date"
                        value={endDate}
                        disabledDate={disabledEndDate}
                        onChange={date => setEndDate(date)}
                        allowClear={false}
                      />
                    </div>
                  </div>

                  <div className='col-md-auto'>
                    <div className="SwFormGroup">
                      <label className="SwFormLabel invisible">No Label</label>
                      <SwButton
                        type="button"
                        variant="primary"
                        size="sm"
                        onClick={handleApply}
                        disabled={!startDate || !endDate}
                      >
                        Apply
                      </SwButton>
                    </div>
                  </div>

                  <div className='col-md-auto ms-auto'>
                    <div className="SwFormGroup">
                      <label className="SwFormLabel invisible">No Label</label>
                      <SwButton
                        type="button"
                        variant="dark"
                        size="sm"
                        onClick={handleExport}
                        disabled={filteredCompanyPointData.length === 0}
                        icon={<i className="bi bi-box-arrow-up-right" />}
                        iconPosition="start"
                      >
                        Export
                      </SwButton>
                    </div>
                  </div>

                </div>

                <div className="row">
                  <div className="col-12">
                    
                      <div className="">
                        <AntDTable
                          columns={columns}
                          dataSource={filteredCompanyPointData || []}
                          rowKey="id"
                          loading={spinner}
                          pagination
                          pageSize={25}
                          clientSideSorting={true}
                          scroll={{ x: 1200 }}
                        />

                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
    </>
  );
}

export default connect()(MealPlanTransaction);
